import * as v from "valibot";

import { rpcContract } from "../rpc";

export interface BulkImportLog {
  id: string;
  timestamp: Date;
  input: string[];
  message: string;
}

export const bulkImportLogsRpcContract = rpcContract({
  name: "bulkImportLogs",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    logs: v.array(
      v.object({
        id: v.string(),
        timestamp: v.string(),
        input: v.array(v.string()),
        message: v.string(),
      }),
    ),
  }),
});

export type BulkImportLogsParams = v.InferInput<(typeof bulkImportLogsRpcContract)["paramsSchema"]>;
export type BulkImportLogsResult = v.InferOutput<(typeof bulkImportLogsRpcContract)["resultSchema"]>;
